const React = require("react");
const T = React.PropTypes;

require("./Root.less");

const MainViewNames = require("../config.js").MainViewNames;
const AppState = require("../types/AppState.js");
const navigator = require("~/navigator.js");

const userLoadDispatchers = require("~/events/userLoad/userLoadDispatchers.js");
const auditCompletionDispatchers = require("~/events/auditCompletion/auditCompletionDispatchers.js");

const Main = require("./Main/Main.jsx");
const Nav = require("./Nav/Nav.jsx");
const Banner = require("./Banner/Banner.jsx");
const UnauthorizedError = require("./UnauthorizedError/UnauthorizedError.jsx");
const MajorError = require("./MajorError/MajorError.jsx");
const MajorLoading = require("./MajorLoading/MajorLoading.jsx");
const MajorMessage = require("./MajorMessage/MajorMessage.jsx");

const Survey = require("./Survey/Survey.jsx");
const SurveyList = require("./SurveyList/SurveyList.jsx");
const LegacySurvey = require("./LegacySurvey/LegacySurvey.jsx");
const SurveySummary = require("./SurveySummary/SurveySummary.jsx");
const Impersonation = require("./Impersonation/Impersonation.jsx");
const SurveyConfirmation = require("./SurveyConfirmation/SurveyConfirmation.jsx");
const WalkThru = require("./WalkThru/WalkThru.jsx");
const Reports = require("./Reports/Reports.jsx"); 
const NotChrome = require("./NotChrome/NotChrome.jsx"); 

const SurveyNav = require("./SurveyNav/SurveyNav.jsx");

const Root = React.createClass({
    propTypes: AppState.PropType,

    componentWillMount() {
        if (this.props.User.Data === null) {
            userLoadDispatchers.LoadCurrentUser();
        }
    },

    componentWillReceiveProps: function (nextProps) {
        if (nextProps.CurrentSurvey.CurrentSectionGUID
                !== this.props.CurrentSurvey.CurrentSectionGUID
            || nextProps.MainViewName
                !== this.props.MainViewName) {
            window.scroll(0, 0);
        }

        // This is the only place where the user gets reloaded,
        // i.e. after impersonation completes.
        if (this.props.ImpersonationTransition.InProgress
            && !nextProps.ImpersonationTransition.InProgress
            && !nextProps.ImpersonationTransition.Error) {
            userLoadDispatchers.LoadCurrentUser();
        }
    },
    isChrome() {
        //Determine whether we're using the chrome browser, block all other browsers. 
        var isChromium = window.chrome,
            winNav = window.navigator,
            vendorName = winNav.vendor,
            isOpera = winNav.userAgent.indexOf("OPR") > -1,
            isIEedge = winNav.userAgent.indexOf("Edge") > -1,
            isIOSChrome = winNav.userAgent.match("CriOS");

        if (isChromium !== null && isChromium !== undefined && vendorName === "Google Inc."
            && isOpera == false && isIEedge == false) return true;
        else return false; 
    },
    render() {
        const message = this.GetMessage();

        const isChrome = this.isChrome();

        if (message !== null) {
            return message;
        }

        const homeURL = this.GetHomeURL();
        const navContent = this.GetNavContent();
        const showNav = navContent !== null;
        const containerClass = this.GetContainerClass(showNav);

        if (isChrome) {
            return (<main className="cs-Root">
            <Banner User={this.props.User.Data}
                    ImpersonationTransitioning={this.props.ImpersonationTransition.InProgress}
                    HomeLinkURL={homeURL
                } />
            {showNav && (<Nav>{navContent}</Nav>)}
            <div className="cs-Root__banner-spacer">{""}</div>
            {showNav && (<div className="cs-Root__nav-spacer">{""}</div>)}
            <div className={containerClass }>
                <div className="cs-Root__container__gutter-left">{""}</div>
                <div className="cs-Root__container__main">
                    <Main>
                        {this.GetView()}
                    </Main>
                </div>
                <div className="cs-Root__container__gutter-right">{""}</div>
            </div>
        </main>);
        }

        return (<NotChrome />)
    },
    GetNavContent() {
        switch (this.props.MainViewName) {
            case MainViewNames.Survey:
            case MainViewNames.SurveyConfirmation:
                return (<SurveyNav Survey={this.props.CurrentSurvey } />);
            default:
                return null;
        };
    },
    GetView() {
        switch (this.props.MainViewName) {
            case MainViewNames.SurveyList:
                return (<SurveyList User={this.props.User.Data}
                                    SurveySearchResults={this.props.SurveySearchResults}
                                    SurveyCreationStatus={this.props.SurveyCreationStatus} />);
            case MainViewNames.Survey:
                return (<Survey Survey={this.props.CurrentSurvey } />);
            case MainViewNames.SurveyConfirmation:
                return (<SurveyConfirmation Survey={this.props.CurrentSurvey }
                                            EmailRecipients={this.props.EmailRecipients} />);
            case MainViewNames.SurveySummary:
                return (<SurveySummary Survey={this.props.CurrentSurvey } />);
            case MainViewNames.LegacySurvey:
                return (<LegacySurvey Survey={this.props.CurrentSurvey } />);
            case MainViewNames.Impersonation:
                return (<Impersonation User={this.props.User.Data}
                                       AlterEgos={this.props.AlterEgos }
                                       ImpersonationTransitioning={this.props.ImpersonationTransition.InProgress} />);
            case MainViewNames.WalkThru:
                return (<WalkThru WalkThru={this.props.WalkThru } />);
            case MainViewNames.Reports:
                return (<Reports User={this.props.User.Data}
                                 Reports={this.props.Reports}
                                  AuditPeriods={this.props.AuditPeriods}
                                  CompleteReport={this.props.CompleteReport}
                                  DistrictReport={this.props.DistrictReport}
                                  Loading={this.props.LoadingCompleteReport} />);
            default:
                return (<SurveyList User={this.props.User.Data}
                                    SurveySearchResults={this.props.SurveySearchResults}
                                    SurveyCreationStatus={this.props.SurveyCreationStatus} />);
        };
    },
    GetContainerClass(showNav) {
        if (showNav) {
            return "cs-Root__container-with-nav";
        }

        return "cs-Root__container-without-nav";
    },
    GetMessage() {
        if (this.props.UnauthorizedError) {
            return (<main className="cs-Root__message">
                <UnauthorizedError Error={this.props.UnauthorizedError } />
            </main>);
        }

        if (this.props.User.Error) {
            return (<main className="cs-Root__message">
                <MajorError Error={this.props.User.Error} />
            </main>);
        }

        if (this.props.ImpersonationTransition.Error) {
            return (<main className="cs-Root__message">
                <MajorError Error={this.props.ImpersonationTransition.Error} />
            </main>);
        }

        if (this.props.User.Data === null) {
            return (<main className="cs-Root__message">
                <MajorLoading />
            </main>);
        }

        if (this.props.SurveySubmissionStatus.Error) {
            const submissionError = this.GetSubmissionError();

            return (<main className="cs-Root__message">
                {submissionError}
            </main>);
        }

        if (this.props.SurveySubmissionStatus.InProgress) {
            return (<main className="cs-Root__message">
                <MajorMessage>
                    <h1>
                        Audit submission in progress...
                    </h1>
                </MajorMessage>
            </main>);
        }

        return null;
    },
    GetSubmissionError() {
        return (<div>
            <h2 className="cs-Root__message__line">
                There was a problem submitting the survey.
            </h2>
            <h3 className="cs-Root__message__line">
                First thing to do is go back and submit again.
                &nbsp;
                <button className="btn btn-primary"
                        onClick={this.ClearSubmissionError}>
                    Click here to try it again
                </button>
            </h3>
            <h3 className="cs-Root__message__line">
                If that doesn't work, please contact Support Services.
            </h3>
            <MajorError Error={this.props.SurveySubmissionStatus.Error } />
        </div>);
    },
    ClearSubmissionError() {
        auditCompletionDispatchers.ClearError();
    },
    GetHomeURL() {
        switch (this.props.MainViewName) {
            case MainViewNames.WalkThru:
                if (this.props.CurrentSurvey.GUID) {
                    if (this.props.CurrentSurvey.ConfirmationCode) {
                        const summaryPath = navigator.GetLink.ToSummary(
                            this.props.CurrentSurvey.Type,
                            this.props.CurrentSurvey.FacilityNumber,
                            this.props.CurrentSurvey.GUID);

                        return `#${summaryPath}`;
                    }

                    if(this.props.CurrentSurvey.CurrentSectionGUID) {
                        const sectionPath = navigator.GetLink.ToSection(
                            this.props.CurrentSurvey,
                            this.props.CurrentSurvey.CurrentSectionGUID);

                        return `#${sectionPath}`;
                    }

                    const surveyPath = navigator.GetLink.ToSurvey(
                        this.props.CurrentSurvey.Type,
                        this.props.CurrentSurvey.FacilityNumber,
                        this.props.CurrentSurvey.GUID);

                    return `#${surveyPath}`;
                }

                return "#";
            default:
                return "#";
        };
    }
});

module.exports = Root;


// WEBPACK FOOTER //
// ./src/components/Root.jsx